export * from '../brunswick/constants'
export * from './http'

import { defaultLocale } from '@syconium/weeping-figs'

export { defaultLocale }
export const defaultCurrency: string = 'USD'
